import React, { Component } from "react"

export class Loading extends Component {
  render() {
    return <section className="loading"></section>
  }
}
